// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  display: grid;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-items: center;
  background: url("/assets/imagenes/backgroundNew.jpeg") no-repeat center;
  background-size: cover;
}

.footer-text {
  font-size: 12px;
  color: #8a8a8a;
  text-align: center;
}

a {
  text-decoration: none;
}

h2,
a {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/component/login-failed/login-failed.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,uEAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;;EAEE,gBAAA;AACF","sourcesContent":[".main-container {\r\n  display: grid;\r\n  height: 100%;\r\n  width: 100%;\r\n  align-items: center;\r\n  justify-items: center;\r\n  background: url('/assets/imagenes/backgroundNew.jpeg') no-repeat center;\r\n  background-size: cover;\r\n}\r\n\r\n.footer-text {\r\n  font-size: 12px;\r\n  color: #8a8a8a;\r\n  text-align: center;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n}\r\n\r\nh2,\r\na {\r\n  font-weight: 500;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
